import React, { FC, ReactNode } from "react";

import { Field, Label, Value } from "./styled";

export const FieldValue: FC<{ field?: ReactNode; value?: ReactNode }> = ({ field, value }) => {
  return (
    <Field>
      <Label>{field}</Label>
      <Value>{value}</Value>
    </Field>
  );
};
